import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Comissao, ComissaoItem } from 'src/app/models/comissao';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ComissaoService } from 'src/app/services/comissao.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { CadastrarItemComissaoComponent } from '../cadastrar-item-comissao/cadastrar-item-comissao.component';

// jquery
declare const $: any;

@Component({
  selector: 'app-cadastrar-comissao',
  templateUrl: './cadastrar-comissao.component.html',
  styleUrls: ['./cadastrar-comissao.component.scss']
})
export class CadastrarComissaoComponent implements OnInit, OnDestroy, AfterViewInit {
  // variáveis
  comissao = new Comissao();
  editando = false;
  carregando = true;

  Number = Number;

  editavel = true;

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    private route: ActivatedRoute,
    private notificacaoService: NotificacaoService,
    private comissaoService: ComissaoService,
    private router: Router,
    private carregandoService: CarregandoService,
    private globalService: GlobalService,
    public dialog: MatDialog,
    private utilitarioService: UtilitarioService,
    public dialogRef: MatDialogRef<CadastrarComissaoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {

    this.comissao = this.data.comissao;

    if (!this.comissao.id) {
      this.comissao.itens = [];
      this.atualizaDadosComissao();
    } else {
      this.buscarComissao();
    }




  }

  buscarComissao() {
    this.carregandoService.mostra('buscaComissao');

    this.comissaoService.consultarPorIdComissao(this.comissao.id).subscribe(
      (comissao) => {
        this.comissao = comissao;
        this.comissao.itens.forEach(p => {
          p.situacao = 0;
        });
        this.atualizaDadosComissao();
      },
      (erro) => {
        this.carregandoService.esconde('buscaComissao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  excluirItem(item: ComissaoItem) {
    item.situacao = 2;
  }

  excluirTodosItens() {
    if (this.comissao.itens && this.comissao.itens.length > 0) {

      swal({
        title: 'Deseja realmente Excluir todos os Percentuais?',
        text: '',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-info',
        cancelButtonClass: 'btn btn-danger',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        buttonsStyling: false,
        type: 'warning'
      }).then((result) => {
        if (result.value) {
          this.comissao.itens.forEach(p => { p.situacao = 2; });
        }
      });


    }
  }

  novoItem() {

    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarItemComissaoComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { item: new ComissaoItem(), itens: this.comissao.itens },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: ComissaoItem) => {
      if (result) {

        result.situacao = 1;

        if (!this.comissao.itens) {
          this.comissao.itens = [];
        }

        result.fim = Number(result.fim);
        result.inicio = Number(result.inicio);
        result.valor = Number(result.valor);

        this.comissao.itens.push(result);

        this.ordenaItens();
      }
    });
  }

  editarItem(item: ComissaoItem) {

    const itemParaEditar = new ComissaoItem();

    Object.assign(itemParaEditar, item);

    const largura = Number(($('body').width()));

    const dialogRef = this.dialog.open(CadastrarItemComissaoComponent, {
      width: largura > 730 ? '700px' : (($('body').width()).toString() + 'px'),
      data: { item: itemParaEditar, itens: this.comissao.itens.filter(p => p !== item) },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result: ComissaoItem) => {
      if (result) {
        item.fim = Number(result.fim);
        item.inicio = Number(result.inicio);
        item.valor = Number(result.valor);
        item.situacao = 1;

        this.ordenaItens();
      }
    });
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  atualizaDadosComissao() {
    this.carregandoService.esconde('buscaComissao');
    this.carregando = false;
  }

  salvar() {
    this.carregandoService.mostra('salvaComissao');

    this.comissao.percKitPronto = Number(this.comissao.percKitPronto);

    this.comissaoService.salvar(this.comissao).subscribe(
      (retorno) => {

        this.notificacaoService.sucesso('Tabela de Comissão salva com sucesso!!!');
        this.carregandoService.esconde('salvaComissao');
        this.dialogRef.close(this.comissao);
      },
      (erro) => {
        this.carregandoService.esconde('salvaComissao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscaItensAtivos() {
    return !this.comissao || !this.comissao.itens ? [] : this.comissao.itens.filter(p => p.situacao !== 2);
  }

  ngOnDestroy(): void {

  }

  ordenaItens() {

    this.comissao.itens = this.comissao.itens.sort((a, b) => {
      return this.compare(Number(a.inicio), Number(b.inicio), true);
    });

  }

  compare(a: number | string, b: number | string, isAsc: boolean) {

    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  fechar() {
    this.dialogRef.close();
  }

}
